//默认登录为学生端
import config from './config.js';
import app from './app.js';

const ROLE_CONFIG = {
    root: {
        //内部管理后台-内部使用【系统管理员】
        roleName: '超级管理员',
        roleKey: 'root'
    },
    sysAdmin: {
        //内部管理后台-内部使用【平台管理员】
        roleName: '系统管理员(开发者)',
        roleKey: 'sysAdmin'
    },
    research: {
        //外部管理后台-外部使用【学校管理员】
        roleName: '教研员',
        roleKey: 'research'
    },
    schoolAdmin: {
        //审核端【平台管理员】
        roleName: '学校管理员',
        roleKey: 'schoolAdmin'
    }
};

const getRoleName = function(roleKey) {
    for (let p in ROLE_CONFIG) {
        let item = ROLE_CONFIG[p];
        if (item.roleKey == roleKey) {
            return item;
        }
    }
};
const getRoleNames = function(roleKeys) {
    let roleNames = [];
    for (let p in ROLE_CONFIG) {
        let item = ROLE_CONFIG[p];

        roleKeys.forEach(roleKey => {
            if (item.roleKey === roleKey) {
                roleNames.push(item.roleName);
            }
        });
    }
    return roleNames.toString();
};

/**
 * @param {Object} roles string[] 角角标识集合
 */
const allowLogin = function(roles) {
    let isAllow = false;
    config.allowRoles.forEach(item => {
        roles.forEach(roleKey => {
            if (item === roleKey) {
                isAllow = true;
            }
        });
    });
    return isAllow;
};

/**
 * 判断是否超级管理员
 * @param {Object} roles
 */
const isSuperAdmin = function() {
    const whetherLand = app.whetherLand();
    if (!whetherLand) {
        return false;
    }
    let state = app.getState();
    for (let i = 0; i < state.roles.length; i++) {
        if (state.roles[i] === ROLE_CONFIG.root.roleKey) {
            return true;
        }
    }
    return false;
};

export default {
    getRoleName,
    getRoleNames,
    allowLogin,

    isSuperAdmin
};
